export default {
	tenantId: "luma_uat",
	appId: "admin_portal"
}
